import { render, staticRenderFns } from "./address-comp.vue?vue&type=template&id=fd3d8ca6&scoped=true&"
import script from "./address-comp.vue?vue&type=script&lang=js&"
export * from "./address-comp.vue?vue&type=script&lang=js&"
import style0 from "./address-comp.vue?vue&type=style&index=0&id=fd3d8ca6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3d8ca6",
  null
  
)

export default component.exports